/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { IHerbalTextBlockVideoViewProps } from './herbal-text-block-video';
import { Node } from '@msdyn365-commerce-modules/utilities';
import { IHerbalVideoPlayerProps } from './components/herbal-video-player-popup';

/**
 * Method will render video player.
 * @param videoPlayer -The video player item view props.
 * @returns Jsx element.
 */
const _rederVideoPlayer = (videoPlayer: IHerbalVideoPlayerProps): JSX.Element | undefined => {
    return (
        <>
            <Node {...videoPlayer.videoPlayerWrapper}>
                {videoPlayer.videoPlayerLink}
                {videoPlayer.videoPlayerDialog}
            </Node>
        </>
    );
};

const HerbalTextBlockVideoView: React.FC<IHerbalTextBlockVideoViewProps> = props => (
    <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
        {props.paragraph}
        {props.videoPlayerOptions && _rederVideoPlayer(props.videoPlayerOptions)}
    </div>
);

export default HerbalTextBlockVideoView;
